import {
  getCrawlerJobs,
  setActiveCrawlerJob,
  setFinishedCrawlerJob,
} from '@storeOld/reducers/crawler'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useAuth } from '@/hooks'
import { crawlerClient } from '@/services/crawler'
import type { AppState, CrawlerJobId } from '@/types'

export const useFetchCrawlerJobs = () => {
  const dispatch = useDispatch()
  const { id: userId } = useAuth()

  const [startedCrawlerJob, finishedCrawlerJob] = useSelector<
    AppState,
    Array<CrawlerJobId | null>
  >(getCrawlerJobs)

  const getJobs = async () => {
    const payload = await crawlerClient.getJobs(userId)
    // @todo move action
    // @ts-expect-error
    dispatch(setActiveCrawlerJob(payload.started))
    // @todo move action
    // @ts-expect-error
    dispatch(setFinishedCrawlerJob(payload.finished))
  }

  const hasJobs = !!startedCrawlerJob || !!finishedCrawlerJob

  useEffect(() => {
    getJobs()
  }, [])

  return { startedCrawlerJob, finishedCrawlerJob, hasJobs }
}
